import { GetServerSideProps } from 'next';

import { authorizationHeader } from '@picsart/growth-rc/services/auth';

import Embed from 'components/Embed';

import endpointConstructor from 'utils/shared/endpointConstructor';
import fetcher from 'utils/shared/fetcher';

import { SSRContext } from 'types/SSRContext';

export const getServerSideProps: GetServerSideProps = async ({
  query: { id, h, f, height, width, fl },
  req,
}: SSRContext) => {
  const { image: imageData } = await fetcher(endpointConstructor('i', 'image', { imageId: id }), {
    headers: authorizationHeader(req.tokenData?.access_token),
  });

  return imageData
    ? {
        props: {
          show_edit_history: imageData.show_edit_history || false,
          flexible: Number(fl) || (!width && !height) ? 1 : 0,
          edit_history: imageData.edit_history || null,
          username: imageData.user.username,
          imageHeight: imageData.height,
          imageWidth: imageData.width,
          height: height || '100%',
          title: imageData.title,
          width: width || '100%',
          withHeader: Number(h),
          withFooter: Number(f),
          type: imageData.type,
          src: imageData.url,
          id,
        },
      }
    : { props: {} };
};

export default Embed;
